import { chatConsumer } from "./consumer"

// One appearance subscription per tab, kept across Turbo visits (the JS
// context survives them). A heartbeat every 30s carries whether the person
// is active: Soshiki visible and some interaction in the last few minutes.
// Extra heartbeats fire on focus, visibility and the first move after idle,
// so a status change reaches the team quickly.
const HEARTBEAT = 30 * 1000
const IDLE_AFTER = 5 * 60 * 1000

export function startAppearance() {
  if (!document.body?.dataset.userId) return

  let lastInteraction = Date.now()
  let lastActive = null

  const active = () => document.visibilityState === "visible" && Date.now() - lastInteraction < IDLE_AFTER

  const subscription = chatConsumer().subscriptions.create({ channel: "Chat::AppearanceChannel" }, {
    beat(force = false) {
      const now = active()
      if (force || now !== lastActive) {
        lastActive = now
        this.perform("heartbeat", { active: now })
      }
    }
  })

  const touch = () => {
    lastInteraction = Date.now()
    subscription.beat()   // may flip us back to active
  }

  for (const event of ["pointerdown", "keydown", "pointermove", "scroll", "focus"]) {
    document.addEventListener(event, touch, { passive: true })
  }
  document.addEventListener("visibilitychange", () => subscription.beat(true))

  // Steady beat so a hidden or idle tab still reports, and stale ones expire.
  setInterval(() => subscription.beat(true), HEARTBEAT)
}
